// Session of the acknowledgement: its end comes from back-hia (`sessionTimeOut` of ack-start), never from a
// constant of the page. Pure functions (clock passed in).

// Accepts an ISO-8601 string, an epoch in seconds (Jackson timestamps, possibly decimal) or in milliseconds.
export const parseInstant = (value) => {
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
        return value < 1e11 ? Math.round(value * 1000) : Math.round(value);
    }
    if (typeof value === 'string' && value.trim() !== '') {
        if (/^\d+(\.\d+)?$/.test(value.trim())) return parseInstant(Number(value));
        const parsed = Date.parse(value);
        return Number.isNaN(parsed) ? null : parsed;
    }
    return null;
};

// End of the session in the DEVICE clock: remaining = sessionTimeOut - server "now" (the Date header of the
// ack-start response), then counted down locally. Without a readable sessionTimeOut, the tenant session
// duration (ackSettings.sessionDurationSeconds) from now. Neither: null (no countdown shown).
export const computeSessionEnd = (convention, serverDate, clientNow) => {
    const end = parseInstant(convention && convention.sessionTimeOut);
    if (end !== null) {
        const serverNow = parseInstant(serverDate);
        const remaining = end - (serverNow !== null ? serverNow : clientNow);
        return clientNow + Math.max(0, remaining);
    }
    const settings = convention && convention.ackSettings;
    const duration = settings && settings.sessionDurationSeconds;
    if (Number.isInteger(duration) && duration > 0) return clientNow + duration * 1000;
    return null;
};

const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

// "m:ss" or "h:mm:ss".
export const formatRemaining = (ms) => {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
};

// Link validity of the tenant, in the largest whole unit: { unit: 'days' | 'hours' | 'minutes', value }.
export const linkValidity = (seconds) => {
    if (!Number.isInteger(seconds) || seconds <= 0) return null;
    if (seconds % 86400 === 0) return { unit: 'days', value: seconds / 86400 };
    if (seconds % 3600 === 0) return { unit: 'hours', value: seconds / 3600 };
    return { unit: 'minutes', value: Math.max(1, Math.round(seconds / 60)) };
};
